import React, { useEffect } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { useAuthStore } from "../stores/auth-store";
import { LoadingSpinner } from "../components/UI/LoadingSpinner";
import CompanyAdminProhibited from "../components/CompanyAdmin/CompanyAdminProhibited";
import Pod24AdminPRohibited from "../components/Pod24Admin/Pod24AdminProhibited";
import { companyUseCase } from "../../di/container";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const CompanyProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
}) => {
  const [isVerifying, setIsVerifying] = React.useState(true);
  const [isBlocked, setIsBlocked] = React.useState(false);

  const { user } = useAuthStore();
  const { companyId } = useParams();
  useEffect(() => {
    if (!user || !companyId) {
      return;
    }
    (async () => {
      try {
        const fetchedCompanyInfo = await companyUseCase.getCompanyInfo(
          {companyId: Number(companyId)}
        );
        setIsVerifying(false);
      } catch (e: unknown) {
        setIsBlocked(true);
      }
    })();
  }, [companyId, user, user?.companyId]);

  return (
    <>
      {isBlocked ? (
        <CompanyAdminProhibited />
      ) : (
        <>
          {isVerifying ? (
            <div className="flex justify-center items-center h-[100vh]">
              <LoadingSpinner />
            </div>
          ) : (
            children
          )}
        </>
      )}
    </>
  );
};
